import Popup from '@/components/Popup/PopUp/PopUp';
import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel,
  onConfirm,
  onClose,
}: ConfirmModalProps) => {
  return (
    <Popup variant="danger" isOpen={isOpen} handleClose={onClose}>
      <div className="flex gap-4 h-full">
        <img className="rounded-lg bg-danger-50 w-12 h-12 p-2" src="/icons/ban.svg" alt="" />

        <div>
          <Text.Big weight="bold" className="text-danger-60">
            {title}
          </Text.Big>
          <Text.Regular className="text-danger-60 mb-4">{message}</Text.Regular>
          <Button
            prefixIcon={<img src="/icons/check.svg" alt="" />}
            label={confirmLabel}
            size="s"
            className="!w-40 !bg-danger-60 mr-4 hover:!bg-danger-40"
            onClick={onConfirm}
          />
          <Button
            prefixIcon={<img src="/icons/ban_red.svg" alt="" />}
            label="Cancel"
            variant="transparent"
            onClick={onClose}
            className="!w-28 border !border-danger-60 hover:border-danger-40 text-danger-50"
            size="s"
          />
        </div>
      </div>
    </Popup>
  );
};

export default ConfirmModal;
